import LocalityUpdate from './LocalityUpdate'
export {LocalityUpdate}
export default LocalityUpdate
